import React, { useState } from "react";
import { Col, Row, Card, CardBody, Progress, Table, Spinner } from "reactstrap";
import { Icon } from "@iconify/react";
import { getCustomerDetails } from "../../../../api/customer";
import { getPlanDetails } from "../../../../api/customer";
import Chart from "react-apexcharts";
import { useEffect } from "react";
import CreditPanel from "./CreditPanel";
import axios from "axios";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const DashboardDesign = () => {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [userName, setUserName] = useState("User");
  const employerReducer = useSelector((state) => state.employer);
  const planDetails = employerReducer?.planDetails;
  const navigate = useNavigate()
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);

        // 1. Get Token and UserID from localStorage
        const token = localStorage.getItem("webvi_authToken");
        const userId = localStorage.getItem("jobseekerspage_userId");

        if (!token) {
          console.error("No authentication token found!");
          setLoading(false);
          return;
        }

        // 2. API Request with Authorization Header
        const response = await axios.get(
          `https://sdsjobseekers.runasp.net/api/Dashboard/employer?employerId=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Passing the real token here
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.success) {
          setDashboardData(response.data.data);
          setUserName(response.data.data.employerName || "Employer");
        }
      } catch (error) {
        console.error("Auth API Error:", error.response?.data || error.message);
        // If token is expired (401), you might want to redirect to login here
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // Formatting helper for date strings
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Static Chart Options
  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      sparkline: { enabled: true },
    },
    stroke: { curve: "smooth", width: 2 },
    fill: {
      type: "gradient",
      gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05 },
    },
    colors: ["#387ed8"],
  };
  const chartSeries = [{ name: "Views", data: [10, 25, 15, 40, 30, 60, 45] }];

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner color="primary" />
      </div>
    );
  }
  console.log("@@Dashboard Data:", dashboardData);
  console.log("Expiry Date:", dashboardData?.expiryDate);
  console.log("Plan Expiry:", dashboardData?.planExpiry);
  return (
    <div className="p-4 mb-5" style={{ minHeight: "100vh" }}>
      {/* WELCOME SECTION */}
      <Row className="mb-4">
        <Col lg="12">
          <Card
            className="border-0 shadow-sm rounded-4 mt-4"
            style={{
              background: "linear-gradient(90deg, #eef2ff 0%, #f8fafc 100%)",
            }}
          >
            <CardBody className="p-4 bg-light border-0 rounded-3 position-relative overflow-hidden shadow-sm">
              {/* Decorative subtle background gradient for modern look */}
              <div
                className="position-absolute top-0 end-0 bottom-0 start-0 opacity-10 bg-gradient"
                style={{
                  backgroundImage:
                    "linear-gradient(135deg, transparent 60%, var(--bs-primary) 100%)",
                  pointerEvents: "none",
                }}
              />

              <div className="d-flex justify-content-between align-items-center position-relative z-1">
                <div className="me-4">
                  {/* Badge/Context Label */}
                  <span
                    className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill fw-semibold mb-2 text-uppercase tracking-wider"
                    style={{ fontSize: "0.75rem" }}
                  >
                    {dashboardData?.companyName || "Employer Dashboard"}
                  </span>

                  {/* Main Welcome Message */}
                  <h2
                    className="fw-extrabold text-dark mb-2 display-6"
                    style={{ fontSize: "1.75rem", letterSpacing: "-0.5px" }}
                  >
                    Welcome back,{" "}
                    <span className="text-primary">{userName}</span>!
                  </h2>

                  {/* Pro Tip Callout Box */}
                  <div
                    className="bg-white border start-3 border-primary-subtle rounded-3 p-3 mt-3 shadow-sm d-flex align-items-start"
                    style={{ maxWidth: "600px" }}
                  >
                    <div className="me-2 text-primary">
                      <i className="bi bi-lightbulb-fill fs-5"></i>{" "}
                      {/* Requires Bootstrap Icons, otherwise remove this i tag */}
                    </div>
                    <p className="text-secondary mb-0 small lh-base">
                      <strong className="text-dark">Hiring Tip:</strong> Logging
                      in daily bumps your listings to the top of candidate
                      feeds, securing you premium hospitality talent before
                      competitors.
                    </p>
                  </div>
                </div>

                {/* Right Icon Layout */}
                <div
                  className="d-none d-md-flex align-items-center justify-content-center bg-white rounded-circle shadow-sm p-3 flex-shrink-0"
                  style={{ width: "100px", height: "100px" }}
                >
                  <Icon
                    icon="fluent:building-people-24-filled"
                    width="70"
                    className="text-primary"
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        {/* SUBSCRIPTION PLAN CARD */}
        <Col lg="4" className="mb-3">
          <Card className="h-100 border-0 shadow-sm rounded-4 bg-primary text-white">
            <CardBody className="p-4">
              <div className="d-flex justify-content-between mb-3">
                <div>
                  <p className="opacity-75 mb-1">Current Package</p>
                  <h4 className="fw-bold">
                    {dashboardData?.planName || "No Active Plan"}
                  </h4>
                </div>
                <Icon icon="solar:crown-minimalistic-bold-duotone" width="40" />
              </div>
              <div className="mt-4">
                <div className="d-flex justify-content-between small mb-1">
                  <span>Credits Remaining</span>
                  {/* <span>
            {planDetails.balance || 0}/
            {dashboardData?.totalCredits || 0}
          </span> */}
                </div>
                <Progress
                  value={
                    dashboardData?.totalCredits > 0
                      ? (planDetails?.balance / dashboardData.totalCredits) *
                      100
                      : 0
                  }
                  color="warning"
                  className="bg-white bg-opacity-25"
                  style={{ height: "8px" }}
                />
                <p className="mt-3 small opacity-75">
                  Expires: {formatDate(planDetails?.creditsExpiryDate)}
                </p>
              </div>

              <Link
                to="/employer/job/manage"
                className="btn btn-light fw-semibold w-100 mt-2 d-flex align-items-center justify-content-center gap-2"
              >
                <Icon icon="mdi:briefcase-plus-outline" width="18" />
                Post a Job
              </Link>
            </CardBody>
          </Card>
        </Col>

        {/* OVERVIEW STATS */}
        <Col lg="8">
          <Row>
            {[
              {
                label: "Total Posted Jobs",
                value: dashboardData?.allJobsPosted || 0,
                icon: "solar:case-round-bold-duotone",
                color: "text-primary",
                path: "/employer/job/manage",
              },
              {
                label: "Active Jobs",
                value: dashboardData?.activeJobs || 0,
                icon: "mdi:briefcase-check-outline",
                color: "text-success",
                path: "/employer/job/manage",
              },
              {
                label: "Total Applications",
                value: dashboardData?.totalApplications || 0,
                icon: "solar:users-group-rounded-bold-duotone",
                color: "text-primary",
                path: "/employer/job/application/manage",
              },
              {
                label: " Package Days Left",
                value: dashboardData?.daysRemaining || 0,
                icon: "solar:calendar-bold-duotone",
                color: "text-danger",

              },
            ].map((stat, idx) => (
              <Col md="6" xl="3" key={idx} className="mb-3">
                <Card
                  className="border-0 shadow-sm rounded-4 h-100"
                  onClick={() => navigate(stat.path)}
                  style={{ cursor: "pointer" }}
                >
                  <CardBody className="text-center p-4">
                    <div
                      className={`d-inline-flex align-items-center justify-content-center rounded-circle mb-3 ${stat.color} bg-opacity-10`}
                      style={{ width: "50px", height: "50px" }}
                    >
                      <Icon icon={stat.icon} width="28" />
                    </div>
                    <h3 className="fw-bold m-0 text-dark">{stat.value}</h3>
                    <p className="text-muted small mb-0">{stat.label}</p>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <Card className="border-0 shadow-sm rounded-4 mt-3">
            <CardBody className="p-3">
              <h6 className="fw-bold mb-3">Application Performance</h6>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="area"
                height={120}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* JOBS MONITOR TABLE */}
      <CreditPanel />
      <Row>
        <Col lg="12">
          <Link
            to="/employer/job/manage"
            className="text-decoration-none text-dark"
          >
            <Card className="border-0 shadow-sm rounded-4 mt-4">
              <CardBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="fw-bold mb-0">
                    <i className="uil uil-history text-primary me-2"></i>
                    Job Expiration Status
                  </h5>

                  <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2">
                    View All Jobs
                    <i className="uil uil-arrow-right ms-1"></i>
                  </span>
                </div>

                <Table responsive borderless className="align-middle mb-0">
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th className="fw-bold py-3">Job Title</th>
                      <th className="fw-bold py-3">Job Applicants</th>
                      <th className="fw-bold py-3">Job Posted</th>
                      <th className="fw-bold py-3">Days left</th>
                      <th className="fw-bold py-3">Is Expired</th>
                    </tr>
                  </thead>

                  <tbody>
                    {dashboardData?.recentJobs?.filter(
                      (job) => job.isActive === 1,
                    ).length > 0 ? (
                      dashboardData.recentJobs
                        .filter((job) => job.isActive === 1)
                        .map((job, index) => (
                          <tr key={job.id || index}>
                            <td className="fw-bold py-3">{job.jobTitle}</td>

                            <td className="py-3">
                              <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2">
                                {job.applications || 0} Applicants
                              </span>
                            </td>

                            <td className="py-3 text-muted">
                              {moment(job.createdAt).format("MMM DD, YYYY")}
                            </td>

                            <td className="py-3">
                              <span
                                className={`badge rounded-pill px-3 py-2 ${job.daysLeft <= 3
                                    ? "bg-danger bg-opacity-10 text-danger"
                                    : job.daysLeft <= 7
                                      ? "bg-warning bg-opacity-10 text-warning"
                                      : "bg-success bg-opacity-10 text-success"
                                  }`}
                              >
                                {job.daysLeft} Days
                              </span>
                            </td>

                            <td className="py-3">
                              {!job.isJobExpired ? (
                                <span className="badge bg-success bg-opacity-10 text-success rounded-pill border border-success-subtle px-3 py-2">
                                  <i className="uil uil-check-circle me-1"></i>
                                  Active
                                </span>
                              ) : (
                                <span className="badge bg-danger bg-opacity-10 text-danger rounded-pill border border-danger-subtle px-3 py-2">
                                  <i className="uil uil-times-circle me-1"></i>
                                  Expired
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center py-5 text-muted"
                        >
                          <i className="uil uil-folder-open fs-3 d-block mb-2"></i>
                          No active jobs posted recently.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardDesign;
